import { colors } from '@styles/global/colors'
import { ITheme } from '@styles/themes/darkTheme'

export const neonGreen = `#00fbba`
export const neonPink = `#fc6c6c`
export const cobaltBlue = `#20323f`
// export const neonPink = `#f548f5`
export const deepPurple = `#7d56f4`

export const BeautifulLetteringTheme: ITheme = {
  type: 'dark',
  textColor: `#20323f`,
  subheaderColor: `#20323f`,
  headlineColor: neonPink,
  headlineColorAlt: `#20323f`,
  backgroundPrimary: `#fdf7eb`,
  // backgroundPrimary: `#1B1D1D`,
  backgroundSecondary: `#f4f5f9`,
  // backgroundSecondary: `#222525`,
  lineColor: `rgba(226, 234, 242, 0.09)`,
  linkColor: colors.primary.pink,
  linkHoverColor: colors.primary.pink,
  // mainBg: `#1B1D1D`,
  bodyText: `#20323f`,
  highlight: {
    i500: neonPink,
  },
  logoColor: '#20323f', 
  outline: `#3F4B5B`,
  buttonPrimary: {
    backgroundColor: `#fff`,
    backgroundHoverColor: '#20323f',
    textColor: `#1b1d1d`,
    textHoverColor: `#1b1d1d`,
  },
  shadows: {
    i800: {
      hover: `0px 40px 50px rgba(0, 0, 0, 0.5)`,
      init: `0px 40px 50px rgba(0, 0, 0, 0)`,
    },
  },
  nav: {
    openColor: '#000',
    color: '#fff',
    textColor: '#20323f',
    background: '#fff'
  },

}
